/**
* Composition for Campaigns Team Dashboard
*/
export default function () {
  const { confGlobal } = useConfig()
  const { $i18n: i18n } = useNuxtApp()
  const { query } = useRoute()
  const { requestHeaders } = useApi()
  const toast = useToast()

  /**
  * Default Limit
  */
  const defaultLimit = 12

  /**
  * Get Faq Content
  */
  const faqContent = useState('faq_content', () => false)
  const getFaqContent = (paramsData = {}) => {
    try {
      // Get Parameters
      const params = {}

      if (paramsData.page) {
        params.page = paramsData.page
      } else {
        params.page = parseInt(query.page) > 0 ? query.page * 1 : 1
      }

      if (paramsData.limit) {
        params.limit = paramsData.limit
      } else {
        params.limit = defaultLimit
      }

      if (paramsData.filters) {
        params['filters[category_id]'] = paramsData.filters.category_id
        params['filters[search]'] = paramsData.filters.search
      }

      let paramsString = new URLSearchParams(params).toString()
      if (paramsString) {
        paramsString = '?' + paramsString
      }

      /**
      * Request
      */
      return $fetch(confGlobal.apiUrl + `/faq/content${paramsString}`, {
        method: 'GET',
        headers: requestHeaders()
      }).then(async (res) => {
        faqContent.value = await res
      }).catch((err) => {
        console.log(err)

        toast.add({
          severity: 'error',
          detail: i18n?.t('serverError'),
          life: 5000
        })
        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Get Faq Content
  */
  const getFaqVideo = (faqData) => {
    // Get Parameters
    const params = {}
    params.videoUrl = faqData.video_url
    try {
      let paramsString = new URLSearchParams(params).toString()
      if (paramsString) {
        paramsString = '?' + paramsString
      }

      /**
      * Request
      */
      return $fetch(confGlobal.apiUrl + `/faq/video${paramsString}`, {
        method: 'GET',
        headers: requestHeaders()
      }).then(async (res) => {
        faqData.loadedVideo = true
        faqData.video = await res.data
      }).catch((err) => {
        console.log(err)

        toast.add({
          severity: 'error',
          detail: i18n?.t('serverError'),
          life: 5000
        })
        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Get Faq Categories
  */
  const faqCategories = useState('faq_categories', () => false)
  const getFaqCategories = (paramsData = {}) => {
    try {
      // Get Parameters
      const params = {}
      
      if (paramsData.filters) {
        params['filters[search]'] = paramsData.filters.search
      }

      let paramsString = new URLSearchParams(params).toString()
      if (paramsString) {
        paramsString = '?' + paramsString
      }

      /**
      * Request
      */
      return $fetch(confGlobal.apiUrl + `/faq/categories${paramsString}`, {
        method: 'GET',
        headers: requestHeaders()
      }).then(async (res) => {
        faqCategories.value = await res

        return faqCategories.value.data.faq_categories
      }).catch((err) => {
        console.log(err)

        toast.add({
          severity: 'error',
          detail: i18n?.t('serverError'),
          life: 5000
        })
        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Return Object
  */
  return {
    defaultLimit,

    faqContent,
    getFaqContent,

    getFaqVideo,

    faqCategories,
    getFaqCategories
  }
}
